import actionCreators from './actionCreators';

import api from 'media-base-ui/utils/storyAPI';

const fetchStory = (args, partyKey) => async dispatch => {
    dispatch(actionCreators.requestStory(args, partyKey));
    try {
        const { data } = await api.fetchStories(args);
        dispatch(actionCreators.storyResponse(true, [], data.length > 0 ? data[0] : {}, partyKey));
    }
    catch (errors) {
        dispatch(actionCreators.storyResponse(false, errors, [], partyKey));
    }
};

const fetchStoryDetails = (args, partyKey) => async dispatch => {
    dispatch(actionCreators.requestStoryDetail(args, partyKey));
    try {
        let response = await api.fetchStoryDetails(args);
        const data = response.data.length > 0 ? response.data[0] : {};
        dispatch(actionCreators.storyDetailResponse(true, [], data, partyKey));
    }
    catch (errors) {
        dispatch(actionCreators.storyDetailResponse(false, errors, [], partyKey));
    }
};

export default {
	fetchStory,
    fetchStoryDetails,
}